var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgregarEmpresa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 14H18.6667M14 9.33331V18.6666M25.6667 14C25.6667 20.4433 20.4434 25.6666 14 25.6666C7.55672 25.6666 2.33337 20.4433 2.33337 14C2.33337 7.55666 7.55672 2.33331 14 2.33331C20.4434 2.33331 25.6667 7.55666 25.6667 14Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgregarEmpresa);
export default __webpack_public_path__ + "static/media/agregar-empresa.29e5bd504e3a1a8950b794a9410466f2.svg";
export { ForwardRef as ReactComponent };